module.exports = __webpack_public_path__ + "static/media/CBNBanner.dcc61a30.webp";